/**
 * @generated SignedSource<<e0e57c7850dc8f9ca59f7692b48946d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LicenseDefinitionDataKind = "Flex";
export type CreateFlexLicenseDefinitionInput = {
  clientMutationId?: string | null;
  data: FlexLicenseDefinitionDataInput;
};
export type FlexLicenseDefinitionDataInput = {
  excludedNodeIds: ReadonlyArray<string>;
  includedNodeIds: ReadonlyArray<string>;
  name: string;
};
export type createFlexLicenseDefinitionButton_CreateFlexLicenseDefinitionMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateFlexLicenseDefinitionInput;
};
export type createFlexLicenseDefinitionButton_CreateFlexLicenseDefinitionMutation$data = {
  readonly Admin: {
    readonly LicenseDefinition: {
      readonly createFlexLicenseDefinition: {
        readonly edge: {
          readonly node: {
            readonly data: {
              readonly kind: LicenseDefinitionDataKind;
              readonly name: string;
            };
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"editFlexLicenseDefinitionButton_LicenseDefinitionFragment">;
          };
        };
      } | null;
    };
  };
};
export type createFlexLicenseDefinitionButton_CreateFlexLicenseDefinitionMutation = {
  response: createFlexLicenseDefinitionButton_CreateFlexLicenseDefinitionMutation$data;
  variables: createFlexLicenseDefinitionButton_CreateFlexLicenseDefinitionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rootId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "createFlexLicenseDefinitionButton_CreateFlexLicenseDefinitionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LicenseDefinitionAdminMutationSchema",
            "kind": "LinkedField",
            "name": "LicenseDefinition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreateFlexLicenseDefinitionPayload",
                "kind": "LinkedField",
                "name": "createFlexLicenseDefinition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LicenseDefinitionsEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LicenseDefinition",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "editFlexLicenseDefinitionButton_LicenseDefinitionFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "createFlexLicenseDefinitionButton_CreateFlexLicenseDefinitionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LicenseDefinitionAdminMutationSchema",
            "kind": "LinkedField",
            "name": "LicenseDefinition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreateFlexLicenseDefinitionPayload",
                "kind": "LinkedField",
                "name": "createFlexLicenseDefinition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LicenseDefinitionsEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LicenseDefinition",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LicenseDefinitionRootInfo",
                                    "kind": "LinkedField",
                                    "name": "includedNodeIds",
                                    "plural": true,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LicenseDefinitionRootInfo",
                                    "kind": "LinkedField",
                                    "name": "excludedNodeIds",
                                    "plural": true,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "FlexLicenseDefinitionData",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "edge",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cb8803db4391c7ad91870fa1a16f82f8",
    "id": null,
    "metadata": {},
    "name": "createFlexLicenseDefinitionButton_CreateFlexLicenseDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation createFlexLicenseDefinitionButton_CreateFlexLicenseDefinitionMutation(\n  $input: CreateFlexLicenseDefinitionInput!\n) {\n  Admin {\n    LicenseDefinition {\n      createFlexLicenseDefinition(input: $input) {\n        edge {\n          node {\n            id\n            data {\n              __typename\n              name\n              kind\n            }\n            ...editFlexLicenseDefinitionButton_LicenseDefinitionFragment\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment editFlexLicenseDefinitionButton_LicenseDefinitionFragment on LicenseDefinition {\n  id\n  data {\n    __typename\n    ... on FlexLicenseDefinitionData {\n      name\n      includedNodeIds {\n        rootId\n        title\n      }\n      excludedNodeIds {\n        rootId\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "48370b188c8201283eb1cba2761e9284";

export default node;
